/*
  PCP - site interaction tracking (Oct 2026, changelog 119).

  Publishes Shopify web-pixel custom events. The custom pixel "PCP - Site interactions -> GA4"
  (Shopify admin > Settings > Customer events) subscribes to them and forwards them to GA4
  G-3DCSTK21P0. This file never talks to Google itself and never reads consent: the pixel only
  runs for visitors who granted Analytics consent, so nothing leaves the browser otherwise.

  Events published (all prefixed pcp:, the pixel strips the prefix):
    nav_click            any link click, with page area, section and menu path
    menu_open            mobile menu / submenu opened, desktop dropdown hovered open (>= 400ms)
    cart_open            cart drawer opened (icon or after add to cart), with drawer state
    cart_shelf_click     click in the cart drawer suggestion shelf
    cart_item_remove     line removed from the cart
    cart_checkout_click  checkout button (drawer or cart page), with delivery-bar state
    size_guide_open      size chart opened (product form trigger or the Find your fit tile)
    filter_apply         collection filter ticked / unticked, or sort changed
    wishlist_toggle      wishlist heart (Zooomy / Wishify) added or removed
    search               search results page viewed (search_term)

  Already published elsewhere and NOT duplicated here: pcp:back_in_stock_open / _signup
  (assets/pcp-back-in-stock.js), pcp:bespoke_enquiry_click (snippets/buy-buttons.liquid).

  Selectors are read-only: this file changes no markup and no behaviour. Clicks are listened for
  in the capture phase on document, so theme handlers that stop propagation do not hide them.
*/
(function () {
  if (window.__pcpTracking) return;
  window.__pcpTracking = true;

  /* ---------- publish (queued until Shopify.analytics is ready) ---------- */
  var queue = [];
  function ready() {
    return window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function';
  }
  function flush() {
    if (!ready()) return;
    while (queue.length) {
      var q = queue.shift();
      try { Shopify.analytics.publish(q[0], q[1]); } catch (e) {}
    }
  }
  function publish(name, data) {
    var payload = data || {};
    payload.market_country = (window.Shopify && Shopify.country) || '';
    payload.device_type = deviceType();
    queue.push(['pcp:' + name, payload]);
    flush();
  }
  var tries = 0;
  var timer = setInterval(function () {
    flush();
    if (ready() || ++tries > 40) clearInterval(timer);
  }, 250);

  /* ---------- helpers ---------- */
  function deviceType() {
    var w = window.innerWidth || 1024;
    if (w < 750) return 'mobile';
    if (w < 990) return 'tablet';
    return 'desktop';
  }
  function clean(s, max) {
    return String(s || '').replace(/\s+/g, ' ').trim().slice(0, max || 100);
  }
  function labelOf(el) {
    if (!el) return '';
    var lab = el.querySelector && el.querySelector('.label');
    var t = clean((lab && lab.textContent) || el.textContent);
    if (!t) t = clean(el.getAttribute && (el.getAttribute('aria-label') || el.getAttribute('title')));
    if (!t) {
      var img = el.querySelector && el.querySelector('img[alt]');
      t = clean(img && img.getAttribute('alt'));
    }
    return t;
  }
  function pathOf(url) {
    try {
      var u = new URL(url, location.href);
      if (u.host !== location.host) return u.host + u.pathname;
      return u.pathname.replace(/^\/en-[a-z]{2}(?=\/|$)/, '') || '/';
    } catch (e) { return ''; }
  }
  function linkType(url) {
    try {
      var u = new URL(url, location.href);
      if (u.host !== location.host) return 'external';
      var p = pathOf(url);
      if (p === '/') return 'home';
      var m = p.match(/^\/(collections|products|pages|blogs|search|cart|account)/);
      if (m) return /\/products\//.test(p) ? 'product' : m[1].replace(/s$/, '');
      return 'other';
    } catch (e) { return 'other'; }
  }
  function sectionKey(el) {
    var s = el.closest && el.closest('[id^="shopify-section-"]');
    if (!s) return '';
    return s.id.replace(/^shopify-section-/, '').replace(/^.*__/, '');
  }
  function areaOf(el) {
    if (el.closest('#menu-drawer, .menu-drawer')) return 'mobile_menu';
    if (el.closest('.header__inline-menu')) return 'header_menu';
    if (el.closest('predictive-search, .search-modal')) return 'search';
    if (el.closest('#mini-cart, cart-drawer')) return 'cart_drawer';
    if (el.closest('.announcement-bar')) return 'announcement';
    if (el.closest('sticky-header, header-wrapper, .header-wrapper, .header')) return 'header_icon';
    if (el.closest('footer, .footer')) return 'footer';
    if (el.closest('.breadcrumb, .breadcrumbs')) return 'breadcrumb';
    if (el.closest('main')) return 'content';
    return 'other';
  }
  // "Shop > By Edit > Block Print" (desktop mega), "ACCESSORIES > Bags" (mobile drawer)
  function menuPath(a) {
    var parts = [];
    var el = a.parentElement;
    while (el && el !== document.body) {
      if (el.matches('.mega-menu__item')) {
        var g = el.querySelector(':scope > .mega-menu__item-link');
        if (g && g !== a) parts.unshift(labelOf(g));
      } else if (el.matches('.footer-block')) {
        var fh = el.querySelector('.accordion__title, .footer-block__heading');
        if (fh) parts.unshift(labelOf(fh));
        break;
      } else if (el.matches('li')) {
        var lab = el.querySelector(':scope > a, :scope > summary, :scope > details > summary, :scope > * > a, :scope > * > summary, :scope > * > details > summary');
        if (lab && lab !== a && !lab.contains(a)) parts.unshift(labelOf(lab));
      }
      if (el.matches('#menu-drawer, .header__inline-menu')) break;
      el = el.parentElement;
    }
    parts.push(labelOf(a));
    var out = [];
    parts.forEach(function (p) { if (p && out[out.length - 1] !== p) out.push(p); });
    return clean(out.join(' > '), 100);
  }
  function deliveryState(root) {
    var bar = (root || document).querySelector('.pcp-delivery');
    if (!bar) return { delivery_bar: 'none' };
    if (bar.classList.contains('pcp-delivery--done')) return { delivery_bar: 'qualified', delivery_gap: 0 };
    var line = bar.querySelector('[role="progressbar"]');
    var max = line ? parseFloat(line.getAttribute('aria-valuemax')) : NaN;
    var now = line ? parseFloat(line.getAttribute('aria-valuenow')) : NaN;
    var out = { delivery_bar: 'short' };
    if (!isNaN(max) && !isNaN(now)) out.delivery_gap = Math.round((max - now) * 100) / 100;
    return out;
  }
  function shelfType(el) {
    var s = el && el.closest('.pcp-shelf');
    if (!s) return 'none';
    return s.classList.contains('pcp-shelf--topup') ? 'topup' : 'pairs';
  }

  /* ---------- clicks ---------- */
  var lastCartIconClick = 0;

  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return; // ignore programmatic clicks (e.g. the size tile clicking the app trigger)
    var t = e.target;
    if (!t || !t.closest) return;

    // cart icon (opens drawer)
    if (t.closest('cart-drawer summary, .cart-drawer-container > summary')) lastCartIconClick = Date.now();

    // size guide: app trigger in the product form, or the Find your fit tile
    var tile = t.closest('a[href="#size-guide"]');
    if (tile) { publish('size_guide_open', { size_guide_source: 'tile', page_type: pageType() }); return; }
    if (t.closest('#Avada-SC-button, .Avada-inline-button')) { publish('size_guide_open', { size_guide_source: 'product_form', page_type: pageType() }); return; }

    // cart drawer suggestion shelf
    var shelfItem = t.closest('.pcp-shelf__item');
    if (shelfItem) {
      var add = t.closest('.pcp-shelf__add');
      var action = add ? (add.tagName === 'BUTTON' ? 'quick_add' : 'choose_size') : 'view_product';
      var items = Array.prototype.slice.call(shelfItem.parentElement.children);
      var nameEl = shelfItem.querySelector('.pcp-shelf__name');
      publish('cart_shelf_click', {
        shelf_type: shelfType(shelfItem),
        shelf_action: action,
        shelf_position: items.indexOf(shelfItem) + 1,
        product_id: shelfItem.getAttribute('data-product-id') || '',
        product_name: clean(nameEl && nameEl.textContent),
      });
      return;
    }

    // cart line removed
    var rm = t.closest('cart-remove-button');
    if (rm) {
      var rl = rm.querySelector('a');
      var title = clean(rl && rl.getAttribute('aria-label')).replace(/^Remove\s+/i, '');
      publish('cart_item_remove', { product_name: title, cart_source: rm.closest('#mini-cart, cart-drawer') ? 'drawer' : 'cart_page' });
      return;
    }

    // checkout buttons
    var co = t.closest('button[name="checkout"], input[name="checkout"]');
    if (co) {
      var inDrawer = !!co.closest('#mini-cart, cart-drawer');
      var st = deliveryState(inDrawer ? co.closest('#mini-cart, cart-drawer') : document);
      st.checkout_source = inDrawer ? 'drawer' : 'cart_page';
      publish('cart_checkout_click', st);
      return;
    }

    // mobile menu: hamburger and submenu openers
    var sum = t.closest('summary');
    if (sum) {
      if (sum.closest('header-drawer, .menu-drawer-container') && !sum.closest('#menu-drawer')) {
        var d = sum.parentElement;
        if (d && !d.hasAttribute('open')) publish('menu_open', { menu_area: 'mobile_menu', menu_label: 'Menu' });
        return;
      }
      if (sum.closest('#menu-drawer')) {
        var dd = sum.parentElement;
        if (dd && !dd.hasAttribute('open')) publish('menu_open', { menu_area: 'mobile_menu', menu_label: labelOf(sum) });
        return;
      }
    }

    // links
    var a = t.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^(javascript|mailto|tel):/i.test(href)) return;
    if (a.closest('.buy-buttons__enquire-link')) return; // bespoke_enquiry_click covers it
    var area = areaOf(a);
    var data = {
      link_area: area,
      link_section: sectionKey(a),
      link_text: labelOf(a),
      link_url: pathOf(a.href),
      link_type: linkType(a.href),
      page_type: pageType()
    };
    if (area === 'header_menu' || area === 'mobile_menu' || area === 'footer') data.menu_path = menuPath(a);
    if (a.closest('.card-wrapper, .card, .product-card, .card-product')) {
      data.link_context = 'product_card';
      data.link_text = data.link_text.replace(/^Pink City Prints\s+/i, '');
    }
    publish('nav_click', data);
  }, true);

  function pageType() {
    var p = pathOf(location.href);
    if (p === '/') return 'home';
    var m = p.match(/^\/(collections|products|pages|blogs|search|cart|account)/);
    if (!m) return 'other';
    if (m[1] === 'collections' && /\/products\//.test(p)) return 'product';
    return m[1].replace(/s$/, '');
  }

  /* ---------- desktop dropdowns: count a hover that stays open >= 400ms ---------- */
  var hoverTimer = null;
  document.addEventListener('mouseover', function (e) {
    var li = e.target.closest && e.target.closest('.header__inline-menu .list-menu--inline > li');
    if (!li || li.__pcpHover) return;
    if (!li.querySelector('.list-menu-dropdown, details, .list-menu-drawer')) return;
    li.__pcpHover = true;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      if (li.matches(':hover')) {
        var top = li.querySelector('.header__menu-item--top');
        publish('menu_open', { menu_area: 'header_menu', menu_label: labelOf(top) });
      }
    }, 400);
    li.addEventListener('mouseleave', function () { li.__pcpHover = false; }, { once: true });
  }, true);

  /* ---------- cart drawer opened ---------- */
  function watchCartDrawer() {
    var det = document.querySelector('cart-drawer details, .cart-drawer-container');
    if (!det || det.__pcpWatched) return;
    det.__pcpWatched = true;
    var wasOpen = det.hasAttribute('open');
    new MutationObserver(function () {
      var isOpen = det.hasAttribute('open');
      var opened = isOpen && !wasOpen; // the theme sets [open] more than once per opening
      wasOpen = isOpen;
      if (!opened) return;
      var trigger = Date.now() - lastCartIconClick < 1500 ? 'icon' : 'add_to_cart';
      // the shelf loads by fetch after the drawer renders, so read the drawer a moment later
      setTimeout(function () {
        var root = document.getElementById('mini-cart') || det;
        var data = deliveryState(root);
        var shelf = root.querySelector('.pcp-shelf');
        data.cart_trigger = trigger;
        data.shelf_type = shelfType(shelf);
        data.shelf_items = shelf ? shelf.querySelectorAll('.pcp-shelf__item').length : 0;
        data.low_stock_lines = root.querySelectorAll('.pcp-cart-low').length;
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            data.cart_items = c.item_count;
            data.value = Math.round(c.total_price) / 100;
            data.currency = c.currency;
          })
          .catch(function () {})
          .then(function () { publish('cart_open', data); });
      }, 1200);
    }).observe(det, { attributes: true, attributeFilter: ['open'] });
  }

  /* ---------- filters + sort ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // wishlist (Zooomy / Wishify heart is a checkbox)
    var wl = t.closest('#ZlistWishlist, [id^="ZlistWishlist"], .ZooomyList, [id^="ZooomyList"]');
    if (wl && t.type === 'checkbox') {
      var host = t.closest('[data-handle], [data-product-id]') || wl;
      publish('wishlist_toggle', {
        wishlist_action: t.checked ? 'add' : 'remove',
        product: host.getAttribute('data-handle') || '',
        product_name: clean(host.getAttribute('data-title')),
        page_type: pageType()
      });
      return;
    }

    if (!t.closest('facet-filters-form, .facets, #FacetFiltersForm, #FacetFiltersFormMobile, .mobile-facets')) return;
    if (t.name === 'sort_by') {
      publish('filter_apply', { filter_name: 'Sort', filter_value: clean(t.value, 60), filter_action: 'sort', collection: pathOf(location.href) });
      return;
    }
    if (t.type !== 'checkbox' && t.type !== 'radio') return;
    var det = t.closest('details');
    var nameEl = det && det.querySelector('summary > span > span:first-child, summary .facets__summary-label, summary > span, summary');
    var lab = t.id && document.querySelector('label[for="' + t.id + '"]');
    publish('filter_apply', {
      filter_name: clean(nameEl && nameEl.textContent, 60).replace(/<.*$/, '').replace(/\s*\(\d+\)\s*$/, '').trim(),
      filter_value: clean((lab && lab.textContent) || t.value, 60).replace(/\s*\(\d+\)\s*$/, ''),
      filter_action: t.checked ? 'add' : 'remove',
      collection: pathOf(location.href)
    });
  }, true);

  /* ---------- search results page ---------- */
  function searchPage() {
    if (pageType() !== 'search') return;
    var q = new URLSearchParams(location.search).get('q');
    if (q) publish('search', { search_term: clean(q, 100) });
  }

  function init() {
    watchCartDrawer();
    searchPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
